import React, { Component } from 'react';
import { navigate, Link } from '@reach/router'; 
import { withFirebase } from '../components/Firebase';


const SignUpPage = () => (
  <div id="signup">
    <div className="left">
      <div>
        <div className="logo"><h1><img src='./img/logo.svg' alt="logo"></img></h1></div>
        <h2>Hi!</h2>
        <h5>We're here to help you track your spending money.</h5>
        <h5>That's the extra money after all of your bills are paid.</h5>
        <SignUpForm />
        <div className="image"><img src='./img/rain.svg' alt="make it rain cash"></img></div>
      </div>
    </div>
    <div className="right">
      <div>
        <div className="image"><img src='./img/wallet.svg' alt="money in a wallet"></img></div>
        <h2>Already have an account?</h2>
        <SignInForm />
      </div>
    </div>
  </div>
);

const INITIAL_STATE = {
  email: '',
  password: '',
  error: null,
};


class SignUpFormBase extends Component {
  constructor(props) {
    super(props);

    this.state = { ...INITIAL_STATE };
  }

  logout = e => {
    this.props.firebase.doSignOut()
    .then(() => {
      this.setState({ ...INITIAL_STATE })
      navigate('/signup')
      e.preventDefault();
    })
  }

  guestLogin = event => {
    this.props.firebase.doSignInAsGuest()
    .then((authUser) => {
      return this.props.firebase
        .user(authUser.user.uid).set({ email: 'Guest' })
    })
    .then(() => {
      this.setState({ ...INITIAL_STATE })
      navigate('/budget')
    })
    .catch(error => {
      this.setState({ error })
    });
    event.preventDefault();
  }

  onSubmit = (event) => {
    
    const { email, password } = this.state;

    this.props.firebase.doCreateUserWithEmailAndPassword(email, password)
      .then((authUser) => {
        return this.props.firebase
          .user(authUser.user.uid).set({ email, budget: 0.00 });
        })    
      .then(() => {
        this.setState({ ...INITIAL_STATE })
        navigate('/budget')
      })
      .catch(error => {
        this.setState({ error });
      });
      event.preventDefault();
  };

  onChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  }

  render() {
    const { email, password, error } = this.state;
    const isInvalid = password === '' || email === '';
   
    return (
      <div className="form-container">
        <form onSubmit={this.onSubmit} method="POST">
          <label htmlFor="email">Email</label>
          <input name="email" id="email" value={email} onChange={this.onChange} type="email" autoComplete="username" placeholder="user@example.com" />
          <label htmlFor="password">Password</label>
          <input name="password" id="password" value={password} onChange={this.onChange} type="password" autoComplete="new-password" />
          {error && <p className="error">{error.message}</p>}
          <button className="dark" disabled={isInvalid} type="submit">Sign Up</button>
          <button className="light" onClick={this.guestLogin}>Continue as Guest</button>
          <p className="small">Already have an account?</p>   <span className="login-link"><Link to="/login">Log In</Link></span>
        </form>
      </div>
    );
  }
}

const SignUpForm = withFirebase(SignUpFormBase);

class SignInFormBase extends Component {
  constructor(props) {
    super(props);

    this.state = { ...INITIAL_STATE };
  }

  forgotPassword = (e) => {
    const emailAddress = this.state.email;
    if (emailAddress !== '') {
      this.props.firebase.doPasswordReset(emailAddress).then(() => {
        this.setState({ emailError: 'Check your email to reset your password.' })
      }).catch(error => {
        this.setState({ error })
      })
    } else {
      this.setState({ emailError: 'Please enter your email address' })
    }
    e.preventDefault()
  }

  guestLogin = event => {
    this.props.firebase.doSignInAsGuest()
    .then((authUser) => {
      return this.props.firebase
        .user(authUser.user.uid).set({ email: 'Guest' })
    })
    .then(() => {
      this.setState({ ...INITIAL_STATE })
      navigate('/')
    })
    .catch(error => {
      this.setState({ error })
    });
    event.preventDefault();
  }

  onSubmit = (event) => {
    
    const { email, password } = this.state;

    this.props.firebase.doSignInWithEmailAndPassword(email, password)  
      .then(() => {
        this.setState({ ...INITIAL_STATE })
        navigate('/')
      })
      .catch(error => {
        this.setState({ error });
      });
      event.preventDefault();
  };

  onChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  }

  render() {
    const { email, password, error } = this.state;
    const isInvalid = password === '' || email === '';
   
    return (
      <div className="form-container">
        <form onSubmit={this.onSubmit} method="POST">
          <label htmlFor="email">Email</label>
          <input name="email" id="email" value={email} onChange={this.onChange} type="email" autoComplete="username" placeholder="user@example.com" />
          <label htmlFor="password">Password</label>
          <input name="password" id="password" value={password} onChange={this.onChange} type="password" autoComplete="current-password" />
          <span onClick={this.forgotPassword} className="forgot">Forgot Password?</span>
          <span className="error">{this.state.emailError}</span>
          {error && <p className="error">{error.message}</p>}
          <button className="light" disabled={isInvalid} type="submit">Log In</button>
        </form>
        <p className="small">Need to sign up?   <span><Link to="/login">    Sign Up -></Link></span></p>
      </div>
    );
  }
}

const SignInForm = withFirebase(SignInFormBase);


export default SignUpPage;

export { SignUpForm, SignInForm }